import { Component } from '@angular/core';
import { AccountBalanceWidgetComponent } from '../../../dashboard/widgets/account-balance-widget/account-balance-widget.component';
import { CircleGraphComponent } from '../../../../../shared/components/circle-graph/circle-graph.component';
import { CurrencyPipe, NgClass } from '@angular/common';
import { EmptyIndicatorPipe } from '../../../../../shared/pipes/empty-indicator.pipe';

@Component({
  selector: 'app-card-topups-balance-widget',
  imports: [CircleGraphComponent, CurrencyPipe, EmptyIndicatorPipe, NgClass],
  templateUrl: './card-topups-balance-widget.html',
  styleUrl: './card-topups-balance-widget.scss',
})
export class CardTopupsBalanceWidget extends AccountBalanceWidgetComponent {}
